"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeveloperInfoPanel = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _DevInfoPanel = require("./DevInfoPanel");
var _jsxRuntime = require("react/jsx-runtime");
const DeveloperInfoPanel = ({
  errorCode,
  developmentInfo
}) => {
  let errorMessage = 'No error message data';
  let errorStack = 'No stack trace data';
  if (typeof window !== 'undefined') {
    const nextData = window.__NEXT_DATA__;
    const error = nextData?.props?.pageProps?.error;
    if (error?.message) {
      errorMessage = error.message;
    }
    if (error?.stack) {
      errorStack = error.stack;
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Paper, {
    elevation: 3,
    sx: {
      mt: 6,
      p: 4,
      borderRadius: 2,
      border: '1px solid #333'
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      variant: "h6",
      mb: 3,
      children: ["Developer Info", /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
        title: "This information is useful for developers to debug the issue. It includes error messages and stack traces.",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircleFilled, {
          fontSize: "inherit"
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      mb: 3,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
        variant: "subtitle1",
        gutterBottom: true,
        children: ["Message for status code ", errorCode, ":"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "body2",
        sx: {
          whiteSpace: 'pre-wrap',
          color: 'error.main'
        },
        children: errorMessage
      })]
    }), developmentInfo !== undefined && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      mb: 3,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Divider, {
        sx: {
          mb: 2,
          borderColor: '#444'
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DevInfoPanel.DevInfoPanel, {
        developmentInfo: developmentInfo
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "subtitle1",
        gutterBottom: true,
        children: "Stack Trace:"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
        component: "pre",
        sx: {
          p: 2,
          backgroundColor: '#121212',
          borderRadius: 1,
          color: '#ccc',
          fontSize: '0.85rem',
          overflowX: 'auto',
          whiteSpace: 'pre-wrap',
          textAlign: 'left',
          wordBreak: 'break-word',
          maxHeight: 400
        },
        children: errorStack
      })]
    })]
  });
};
exports.DeveloperInfoPanel = DeveloperInfoPanel;
